var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuddledeckUnroadblock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.916,
    viewBox: "0 0 20 17.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2597",
    "data-name": "Group 2597",
    transform: "translate(-680.64 -358.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "roadblock",
    d: "M682.71,361.368v-1.66a1.035,1.035,0,0,0-2.07,0v15a.639.639,0,0,1,.08-.089l1.99-1.957v-1.749h1.77l4.24-4.17,1.45-4.012h2.62l1.39-1.364Zm1.87,8.183h-1.83v-4.4l1.21-2.421h3.08Z",
    transform: "translate(0 0)",
    fill: "#283e76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    d: "M700.351,358.707a.975.975,0,0,0-1.393,0l-.563.564-2.105,2.1-4.161,4.146-4.062,4.047-1.364,1.366-3.726,3.71a.981.981,0,0,0-.277.831.926.926,0,0,0,.277.564.966.966,0,0,0,1.393,0l5.119-5.106h8.895v4.1a1.023,1.023,0,1,0,2.046,0V360A.972.972,0,0,0,700.351,358.707Zm-2.184,6.224-1.344,4.631h-3.044l1.6-4.512,2.332-2.315h.455Z",
    transform: "translate(0)",
    fill: "#283e76"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuddledeckUnroadblock);
export default __webpack_public_path__ + "static/media/huddledeck-unroadblock.d4571a74815d79d10a2d00913ccd1296.svg";
export { ForwardRef as ReactComponent };